import { z } from 'zod';
import { Block, BlockSchema } from './Block.types';

import { BlockType, SpotlightBlockConfigSchema } from './blockConfig/Types';

const SpotlightBlockSchema = BlockSchema.extend({
  blockConfig: SpotlightBlockConfigSchema,
});

export type SpotlightBlock = z.infer<typeof SpotlightBlockSchema>;

export function isSpotlightBlock(block: Block): block is SpotlightBlock {
  return block.blockConfig.type === BlockType.Spotlight;
}
